const state = {
  questionInForm: undefined
};

export default state;
